import React, { useState, memo } from "react";
import Setting from "./Setting";

import { useSelector, useDispatch } from "react-redux";
import {
  toggleChangingMode,
  handleAudio,
  turnMode,
} from "../../../redux/actions/postActions";
import { ReactComponent as CloseSVG2 } from "../../../svg/close2.svg";
import {
  SettingsDiv,
  Header,
  GameMode,
  Mode,
  OtherPages,
  Volume,
} from "./styledComponents";
import { ScalingContainer } from "../../../AppStyled";

import { MessageFactory } from "../../../lib/messages";
import { Protocol, Globals } from "../../../lib/constants";

import useSound from "use-sound";

import forwardSound from "../../../audio/goForward.mp3";
import closeSound from "../../../audio/goBack.mp3";
import switchSound from "./audio/switch.mp3";
import tabClick from "../../../audio/tabClick.mp3";

export const Settings = ({
  clickable,
  isAutoOn,
  handleAbove,
  unBlur,
  handleClean,
  scaleDown,
  display,
  h,
  volume,
  handleVolume,
}) => {
  const dispatch = useDispatch();
  const st = useSelector(
    (s) => s,
    () => { }
  );
  const {
    gameMode,
    audio: { music, sound },
  } = st;
  const [closeSFX] = useSound(closeSound, { volume });
  const [forwardSFX] = useSound(forwardSound, { volume });
  const [switchSFX] = useSound(switchSound, { volume });
  const [tabSFX] = useSound(tabClick, { volume });

  const requestHistory = () => {
    let requesHistory = MessageFactory.createMessage(Protocol.GET_STATS);
    Globals.WS.sendMessage(requesHistory);
  };
  const [provfAnim, setprovfAnim] = useState(false);
  const [histAnim, sethistAnim] = useState(false);
  const [gamerules, setgamerules] = useState(false);
  return (
    <SettingsDiv
      className="SettingsDiv"
      unBlur={unBlur}
      scaleDown={scaleDown}
      style={display ? { display: "flex" } : { display: "none" }}
    >
      <ScalingContainer className="ScalingContainer" h={h}>
        <div>
          <Header>
            <p>SETTINGS</p>
            <CloseSVG2
              onClick={() => {
                if (sound) closeSFX();
                handleAbove(false);
              }}
            />
          </Header>
          <GameMode clickable={clickable && !isAutoOn}>
            <Mode
              active={gameMode === "sonic"}
              onClick={() => {
                if (gameMode !== "sonic") {
                  if (sound) tabSFX();
                  dispatch(turnMode("sonic"));
                  handleClean();
                  dispatch(toggleChangingMode(false));
                  Globals.WS.Disconnect();
                  Globals.WS.Start();
                }
              }}
            >
              <p>sonic</p>
              <div className="yellow">
                <div className="white"></div>
              </div>
            </Mode>
            <Mode
              active={gameMode === "40"}
              onClick={() => {
                if (gameMode !== "40") {
                  if (sound) tabSFX();
                  dispatch(turnMode("40"));
                  handleClean();
                  dispatch(toggleChangingMode(false));
                  Globals.WS.Disconnect();
                  Globals.WS.Start();
                }
              }}
            >
              <p>40</p>
              <div className="yellow">
                <div className="white"></div>
              </div>
            </Mode>
            <Mode
              active={gameMode === "80"}
              onClick={() => {
                if (gameMode !== "80") {
                  if (sound) tabSFX();
                  dispatch(turnMode("80"));
                  handleClean();
                  dispatch(toggleChangingMode(false));
                  Globals.WS.Disconnect();
                  Globals.WS.Start();
                }
              }}
            >
              <p>80</p>
              <div className="yellow">
                <div className="white"></div>
              </div>
            </Mode>
          </GameMode>
          <OtherPages
            style={{ pointerEvents: clickable ? "auto" : "none" }}
            onClick={() => {
              sethistAnim(true);
              if (sound) forwardSFX();

              handleAbove("provFair");
              setTimeout(() => {
                // soundF();
                sethistAnim(false);
              }, 300);
            }}
            animSG={histAnim}
          >
            Provably Fair
          </OtherPages>
          <OtherPages
            onClick={() => {
              setgamerules(true);
              if (sound) forwardSFX();
              handleAbove("gameRules");
              setTimeout(() => {
                setgamerules(false);
              }, 300);
            }}
            animSG={gamerules}
          >
            Game Rules
          </OtherPages>
          <OtherPages
            onClick={() => {
              setprovfAnim(true);
              requestHistory();
              if (sound) forwardSFX();
              handleAbove("History");
              setTimeout(() => {
                setprovfAnim(false);
              }, 300);
            }}
            animSG={provfAnim}
          >
            History
          </OtherPages>

          <Setting
            save={() => {
              if (sound) switchSFX();
              dispatch(
                handleAudio({
                  music: !music,
                  sound,
                  volume,
                })
              );
            }}
            name={"Music"}
            sound={sound}
            on={music}
          />
          <Setting
            save={() => {
              if (!sound) switchSFX();
              dispatch(
                handleAudio({
                  music,
                  sound: !sound,
                  volume,
                })
              );
            }}
            name={"Sound"}
            sound={sound}
            on={sound}
          />
          <Volume
            saveUserSetting={(v) => {
              dispatch(
                handleAudio({
                  sound,
                  music,
                  volume: v,
                })
              );
            }}
            handleVolume={handleVolume}
            value={volume}
            volume={volume}
            sound={sound}
          />
        </div>
      </ScalingContainer>
    </SettingsDiv>
  );
};
export default memo(Settings);
